import {
  descriptionUI,
  radioUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import {
  DisabilityRatingDescription,
  DisabilityRatingLearnMore,
} from '../../../components/FormDescriptions/DisabilityRatingDescriptions';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['benefits--disability-rating-title'];
const INPUT_LABEL = content['benefits--disability-rating-label'];

const SCHEMA_LABELS = {
  lowDisability: content['benefits--disability-rating-low-label'],
  highDisability: content['benefits--disability-rating-high-label'],
  none: content['form--default-no-label'],
};

const { vaCompensationType } = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DisabilityRatingDescription),
    ...descriptionUI(DisabilityRatingLearnMore),
    vaCompensationType: radioUI({
      title: INPUT_LABEL,
      labels: SCHEMA_LABELS,
    }),
  },
  schema: {
    type: 'object',
    required: ['vaCompensationType'],
    properties: { vaCompensationType },
  },
};
